import { Action } from '@ngrx/store';
import { Order, OrderIndexParams } from '@rd/types/order.type';

export enum OrderActionTypes {
  GET_ORDERS = '[Orders] Get orders',
  GET_ORDERS_SUCCESS = '[Orders] Get orders success',
  GET_ORDERS_FAIL = '[Orders] Get orders fail',

  GET_ORDER = '[Orders] Get order',
  GET_ORDER_SUCCESS = '[Orders] Get order success',
  GET_ORDER_FAIL = '[Orders] Get order fail',

  SELECT_ORDER = '[Orders] Select order',
  UNSELECT_ORDER = '[Orders] Unselect order',
  RESET_ORDER_MAP = '[Orders] Reset order map',
}

export class GetOrders implements Action {
  readonly type = OrderActionTypes.GET_ORDERS;

  constructor(public payload: Partial<OrderIndexParams> = {}) {}
}

export class GetOrdersSuccess implements Action {
  readonly type = OrderActionTypes.GET_ORDERS_SUCCESS;

  constructor(public payload: Order[]) {}
}

export class GetOrdersFail implements Action {
  readonly type = OrderActionTypes.GET_ORDERS_FAIL;
}

export class GetOrder implements Action {
  readonly type = OrderActionTypes.GET_ORDER;

  constructor(public payload: string) {}
}

export class GetOrderSuccess implements Action {
  readonly type = OrderActionTypes.GET_ORDER_SUCCESS;

  constructor(public payload: Order) {}
}

export class GetOrderFail implements Action {
  readonly type = OrderActionTypes.GET_ORDER_FAIL;
}

export class SelectOrder implements Action {
  readonly type = OrderActionTypes.SELECT_ORDER;

  constructor(public payload: string) {}
}

export class UnselectOrder implements Action {
  readonly type = OrderActionTypes.UNSELECT_ORDER;
}

export class ResetOrderMap implements Action {
  readonly type = OrderActionTypes.RESET_ORDER_MAP;
}

export type OrderAction =
  | GetOrder
  | GetOrderFail
  | GetOrderSuccess
  | GetOrders
  | GetOrdersFail
  | GetOrdersSuccess
  | SelectOrder
  | UnselectOrder
  | ResetOrderMap;
